<template>
  <div>
    <div class="ui-block">
      <!-- Post -->

      <article class="hentry post">
        <div class="post__author author vcard inline-items">
          <img src="/img/favicon.png" alt="author" class="fit-contain" />
          <p class="h5 card-title">Sorry, you have no activity yet</p>
        </div>
        <span>
          <p class="text-break card-message">
            <router-link
              v-if="inRequestsTab"
              to="/s-app/search-result/book?filter=8"
              class="font-weight-bold modals"
              >Request or offer an item</router-link
            >
            <span v-else @click="openItemModal" class="font-weight-bold modals"
              >Post an item&nbsp;</span
            >
            and start your activity
          </p>
        </span>
      </article>

      <!-- .. end Post -->
      <!-- .. end Post -->
      <!---->
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "SNewSystemMessageActivityPage",
  props: ["inRequestsTab"],
  methods: {
    getTimeAgo(time) {
      return moment(time).fromNow();
    },
    openItemModal() {
      $("#new-item").modal("show");
    },
    openGroupModal() {
      $("#create-group").modal("show");
    },
  },
};
</script>
<style scoped>
.modals {
  cursor: pointer;
  color: #05919b;
}
.card-message {
  margin-left: 102px;
  color: black;
  font-weight: 400;
}
.card-title {
  color: black !important;
  margin-left: 50px;
  font-weight: 400;
}
</style>
